<ol class="steps">
  <li class="step" langkey="order_order" [class.active]="activeStep=='order'"></li><!--Checkout-->
  <ng-container *ngIf="getHasPagerScanStep">
    <li class="step" langkey="callsystem_callsystem" [class.active]="activeStep=='pager'"></li><!--Pager scannen-->
  </ng-container>
  <ng-container *ngIf="getHasCardScanStep">
    <li class="step" langkey="process_order_card_card" [class.active]="activeStep=='card'"></li><!--Karte scannen-->
  </ng-container>
  <ng-container *ngIf="getHasPaymentStep">
    <li class="step" langkey="payment_payment" [class.active]="activeStep=='payment'"></li><!--Bezahlung-->
  </ng-container>
  <ng-container *ngIf="getHasDoneStep">
    <li class="step" langkey="done_done" [class.active]="activeStep=='done'"></li><!--Bestätigung-->
  </ng-container>
</ol>